<template lang="pug">
  .page-description(v-if='value', v-html="display")
</template>

<script>
export default {
  props: {
    value: {

    }
  },
  computed: {
    display () {
      let text = this.value.replace(/style="[^"]*"/g, '')
      text = text.replace(/class="[^"]*"/g, '')
      return text
    }
  }
}
</script>

<style lang="scss">
.page-description{
  overflow: hidden;
  width: 100%;
  padding: 20px 0;
  color: #ddd !important;
  strong {
    color: #ddd !important;
  }
  p {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Description.vue